import React, { useState, useEffect } from "react";
import "../../styles/projectStyles/Confirmation.css";
import { useNavigate } from "react-router-dom";
import Footer from "../HeaderFooter/Footer";
import Steps from "../Steps";
import "react-datepicker/dist/react-datepicker.css";
import "react-circular-progressbar/dist/styles.css";

const Confirmation = () => {
  const projectDescription = JSON.parse(
    localStorage.getItem("projectDescription")
  );
  const pd = JSON.parse(localStorage.getItem("projectId"));

  const [currentStep, setCurrentStep] = useState("Summary");

  const navigate = useNavigate();

  const steps = [
    "Project Description",
    "Tasks and Team",
    "Project Dates",
    "Additional Details",
    "Summary",
  ];

  useEffect(() => {
    localStorage.removeItem("projectDescription");
    localStorage.removeItem("selectedTasks");
    localStorage.removeItem("dateRanges");
    localStorage.removeItem("uploadedFiles");
    localStorage.removeItem("projectId");
  }, []);

  const handleGoToProjects = () => {
    navigate("/projects");
  };

  return (
    <div className="confirmation-container">
      <div className="confirmationScreen">
        <Steps
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          steps={steps}
        />
        <div className="confirmation-header-container">
          <h3 className="confirm">Project {pd ? "Updated" : "Created"}</h3>
          <div className="confirmation-message">
            <img
              src="/images/confirm.svg"
              alt="Confirmation Icon"
              className="confirmation-icon"
            />
            <span>
              Awesome! Project:{" "}
              <strong className="project-address">
                {projectDescription.address || "Not provided"}
              </strong>{" "}
              successfully {pd ? "updated." : "created."}
            </span>
          </div>
        </div>
      </div>

      <div className="button-container">
        <button onClick={handleGoToProjects} className="button go-to-details">
          Go to Projects
        </button>
      </div>

      <Footer />
    </div>
  );
};

export default Confirmation;
